exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".actionIcon-b34fb{cursor:pointer}", ""]);

// Exports
exports.locals = {
	"actionIcon": "actionIcon-b34fb"
};